import { CourseState } from "@/store/types/courseTypes";
import { createSlice } from "@reduxjs/toolkit";
import { getAppliedCourse, getCourseDetail, getCourseList } from "./courseApi";
import {
	setAiCourseFinderAcademicDetails,
	setAiCourseFinderEnglishProficiencyDetails,
} from "@/store/feature/ai-course-finder/aiCourseFinderSlice";

const initialState: CourseState = {
	courseList: [],
	courseDetail: null,
	total: 0,
	courseFilterOptions: [],
	loading: false,
	academicDetails: {
		pastQualification: "",
		pastMathsGrades: "",
		pastEnglishGrades: "",
		pastChemistryGrades: "",
		pastPhysicsGrades: "",
		stream: "",
		passingYear: "",
		gradingSystem: "",
		pastGrades: "",
		selectBoard: "",
		board: "",
	},
	englishProficiencyDetails: {
		test: "",
		listeningScore: "",
		readingScore: "",
		writingScore: "",
		speakingScore: "",
		overallScore: "",
		englishMarks: "",
		selectBoard: "",
	},
	appliedCourseData: [],
};

const courseSlice = createSlice({
	name: "course",
	initialState,
	reducers: {
		setCourseAcademicDetails: (state, action) => {
			const payload = action.payload || {};

			if (Object.keys(payload).length === 0) {
				state.academicDetails = initialState.academicDetails;
				return;
			}

			state.academicDetails = {
				...state.academicDetails,
				...payload,
			};
		},

		setCourseEnglishProficiencyDetails: (state, action) => {
			const payload = action.payload || {};

			// Reset to initial state if payload is empty
			if (Object.keys(payload).length === 0) {
				state.englishProficiencyDetails =
					initialState.englishProficiencyDetails;
				return;
			}

			state.englishProficiencyDetails = {
				...state.englishProficiencyDetails,
				...payload,
			};
		},

		clearCourseDetails: () => initialState,
	},
	extraReducers: (builder) => {
		builder
			.addCase(getCourseList.pending, (state) => {
				state.loading = true;
			})
			.addCase(getCourseList.fulfilled, (state, action) => {
				state.loading = false;
				state.courseList = action.payload.list;
				state.total = action.payload.total;
				state.courseFilterOptions = action.payload.all_course_level;
			})
			.addCase(getCourseList.rejected, (state) => {
				state.loading = false;
			})
			.addCase(getCourseDetail.pending, (state) => {
				state.loading = true;
				state.courseDetail = null;
			})
			.addCase(getCourseDetail.fulfilled, (state, action) => {
				state.loading = false;
				state.courseDetail = action.payload;
			})
			.addCase(getCourseDetail.rejected, (state) => {
				state.loading = false;
				state.courseDetail = null;
			})
			.addCase(getAppliedCourse.pending, (state) => {
				state.loading = true;
				state.courseDetail = null;
			})
			.addCase(getAppliedCourse.fulfilled, (state, action) => {
				state.loading = false;
				state.appliedCourseData = action.payload.data;
			})
			.addCase(getAppliedCourse.rejected, (state) => {
				state.loading = false;
				state.courseDetail = null;
			})

			.addCase(setAiCourseFinderAcademicDetails, (state, action) => {
				const payload = action.payload || {};
				state.academicDetails = {
					...state.academicDetails,
					...payload,
				};
			})

			.addCase(setAiCourseFinderEnglishProficiencyDetails, (state, action) => {
				const payload = action.payload || {};
				state.englishProficiencyDetails = {
					...state.englishProficiencyDetails,
					...payload,
				};
			});
	},
});

export const {
	clearCourseDetails,
	setCourseAcademicDetails,
	setCourseEnglishProficiencyDetails,
} = courseSlice.actions;
export default courseSlice.reducer;
